/**
 * Step id of a manual follow-up — a message the user scheduled from the lead panel or the chat
 * rather than one a campaign created. Mirrors the API's `MANUAL_FOLLOW_UP_STEP_ID`
 * (`apps/api/src/schedule/constants.ts`). It is the only step that can be paused on its own
 * (PREC-2861); the lead-level "Pause outreach" leaves it alone.
 */
export const MANUAL_FOLLOW_UP_STEP_ID = "n99";

export enum ScheduleProcessingState {
	PUBLISHED = "published",
	PENDING = "pending",
	DONE = "done",
	FAILED = "failed",
	SCHEDULED = "scheduled",
}

/**
 * Why a scheduled step failed to send. Mirrors the API's `ScheduleFailureCategory`
 * (`apps/api/src/schedule/utils/schedule-failure.util.ts`), which derives it from the persisted
 * error payload — the raw payload never reaches the browser, so this enum is the only failure
 * detail we have and the whole user-facing wording is keyed off it (`outbox.failure.*`).
 */
export enum ScheduleFailureCategory {
	DISCONNECTED = "DISCONNECTED",
	ALREADY_INVITED = "ALREADY_INVITED",
	RECIPIENT_UNREACHABLE = "RECIPIENT_UNREACHABLE",
	MISSING_LINKEDIN_URL = "MISSING_LINKEDIN_URL",
	MISSING_EMAIL = "MISSING_EMAIL",
	EMAIL_BOUNCED = "EMAIL_BOUNCED",
	LIST_PERSON_DELETED = "LIST_PERSON_DELETED",
	RATE_LIMITED = "RATE_LIMITED",
	INSUFFICIENT_PERMISSIONS = "INSUFFICIENT_PERMISSIONS",
	NOT_CONNECTED = "NOT_CONNECTED",
	TRANSIENT = "TRANSIENT",
	/** The provider timed out mid-send, so the step may or may not have gone out (PREC-4160). */
	TIMED_OUT = "TIMED_OUT",
	UNKNOWN = "UNKNOWN",
	BLACKLISTED = "BLACKLISTED",
	CONTENT_TOO_LONG = "CONTENT_TOO_LONG",
	NO_INMAIL_CREDITS = "NO_INMAIL_CREDITS",
	/** The workspace's credits could not pay for the step's AI snippet (PREC-4287). */
	NOT_ENOUGH_CREDITS = "NOT_ENOUGH_CREDITS",
	/** The message kept a column placeholder the lead had no value for, so it was not sent (PREC-4440). */
	MISSING_COLUMN_VALUE = "MISSING_COLUMN_VALUE",
	/** The invite step stopped the campaign for a lead the sender is already connected to (PREC-4426). */
	ALREADY_CONNECTED = "ALREADY_CONNECTED",
}
